import { Card, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { Close, Delete, Edit, Save } from "@mui/icons-material";
import { Box, Button, Modal, useCommonComponentContext } from "@maysoft/common-component-react";

import useChannel from "./useChannel";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import ChannelService from "../../services/message/Channel.service";

import { IDataChannel, IErrorChannel } from "./useChannel";
import { DiscussionGroupAccess, Mode } from "../../constants/enums";
import { BasicInfoChannel } from "../../components/Channel/basicInfoChannel";

const ChannelEditContainer = (props: {
    mode: Mode;
    id?: string;
    title: string;
    communityId: string;
    onCallBack: () => void;
    onChangeMode?: (value: Mode) => void;

    dataPopup?: {
        openPopup: boolean;
        isShowPopup: boolean;
        onClosePopup: () => void;
    };
}) => {
    const Strings = useStrings();

    const { clientId, organizationId, onError, onSuccess, onHideLoading, onShowLoading } = useCommonComponentContext();

    const [dataError, setDataError] = useState<IErrorChannel>({} as IErrorChannel);
    const [dataDetail, setDataDetail] = useState<IDataChannel>({} as IDataChannel);

    const { handleDeleteChannel, getDataDetailChannel } = useChannel();

    useEffect(() => {
        if (props.dataPopup?.isShowPopup) {
            if (props?.dataPopup?.openPopup) {
                getDetail();
            }
        } else {
            getDetail();
        }
    }, [props.id, props.communityId, props.dataPopup?.isShowPopup, props?.dataPopup?.openPopup]);

    const getDetail = async () => {
        try {
            onShowLoading();

            const newData = await getDataDetailChannel(props.id, props.communityId);

            setDataError({});
            setDataDetail(newData);

            onHideLoading();
        } catch (error) {
            onHideLoading();
            const err = Helpers.renderExceptionError(error);
            onError(err);
        }
    };

    const onChangeValueChannel = async (newValue: any, key: any) => {
        let dataTemp: any = { ...dataDetail };
        let dataErrTemp: any = { ...dataError };

        if (key === "avatarImage") {
            dataTemp["avatarImage"] = newValue?.id;
            dataTemp["avatarImageUrl"] = newValue?.accessUrl;
            dataErrTemp["avatarImage"] = newValue?.error || "";
        } else {
            dataErrTemp[key] = undefined;
            dataTemp[key] = newValue;
        }

        setDataDetail(dataTemp);
        setDataError(dataErrTemp);
    };

    const checkedValidate = () => {
        let isChecked = true;
        let dataErrTemp: any = { ...dataError };

        if (Helpers.isNullOrEmpty(dataDetail?.name)) {
            isChecked = false;
            dataErrTemp["name"] = Strings.Common.REQUIRED;
        }
        if (Helpers.isNullOrEmpty(dataDetail?.description)) {
            isChecked = false;
            dataErrTemp["description"] = Strings.Common.REQUIRED;
        }

        if (!isChecked) {
            setDataError(dataErrTemp);
        }

        return isChecked;
    };

    const handleCreateOrUpdate = async () => {
        if (props.mode === Mode.View) {
            props.onChangeMode && props.onChangeMode(Mode.Update);
            return;
        } else {
            if (!checkedValidate()) {
                return;
            } else {
                try {
                    onShowLoading();

                    const accessMode = Helpers.isNullOrEmpty(dataDetail.accessMode) ? DiscussionGroupAccess.Public : Number(dataDetail.accessMode);

                    if (Helpers.isNullOrEmpty(dataDetail?.id)) {
                        await ChannelService.create({
                            name: dataDetail.name,
                            organizationId: organizationId,
                            description: dataDetail.description,
                            referenceId: dataDetail.referenceId,
                            avatarImage: dataDetail.avatarImage,
                            avatarImageUrl: dataDetail.avatarImageUrl,
                            accessMode: accessMode,

                            clientId: dataDetail.clientId || clientId,
                            communityId: dataDetail.communityId || props.communityId,
                        });
                    } else {
                        await ChannelService.update({
                            id: dataDetail.id,
                            name: dataDetail.name,
                            organizationId: organizationId,
                            referenceId: dataDetail.referenceId,
                            avatarImage: dataDetail.avatarImage,
                            avatarImageUrl: dataDetail.avatarImageUrl,
                            description: dataDetail.description,
                            updateTime: dataDetail.updateTime,
                            accessMode: accessMode,
                        });
                    }

                    const msg = Helpers.isNullOrEmpty(dataDetail?.id) ? Strings.CHANNEL.CREATE_SUCCESS : Strings.CHANNEL.UPDATE_SUCCESS;

                    onSuccess(msg);

                    setDataError({});
                    setDataDetail({});

                    props.onCallBack();

                    if (Helpers.isFunction(props?.dataPopup?.onClosePopup)) {
                        props?.dataPopup?.onClosePopup();
                    }

                    onHideLoading();
                } catch (error: any) {
                    onHideLoading();
                    const err = Helpers.renderExceptionError(error);
                    onError(err);
                }
            }
        }
    };

    return props.dataPopup?.isShowPopup ? (
        <Modal
            fullWidth
            hasActionButton
            closeButton={Strings.Common.CANCEL}
            visible={props?.dataPopup?.openPopup || false}
            buttonAction={props.mode === Mode.View ? Strings.Common.EDIT : Strings.Common.SAVE}
            onAction={() => {
                handleCreateOrUpdate();
            }}
            onClose={() => {
                setDataError({});
                setDataDetail({});
                props?.dataPopup?.onClosePopup();
            }}
        >
            <BasicInfoChannel
                mode={props.mode}
                title={props.title}
                dataError={dataError}
                dataDetail={dataDetail}
                onChangeValue={onChangeValueChannel}
            />
        </Modal>
    ) : (
        <Box>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Box sx={{ display: "flex", alignItems: "flex-end", justifyContent: "end" }}>
                        <Button
                            color="secondary"
                            onClick={() => {
                                props.onCallBack();
                            }}
                        >
                            <Close /> &nbsp; {Strings.Common.CANCEL}
                        </Button>
                        {!Helpers.isNullOrEmpty(props.id) && (
                            <Button
                                sx={{ ml: 2 }}
                                color="error"
                                onClick={() => {
                                    handleDeleteChannel({
                                        channelId: props.id,
                                        onCallBack() {
                                            props.onCallBack();
                                        },
                                    });
                                }}
                            >
                                <Delete /> &nbsp; {Strings.Common.DELETE}
                            </Button>
                        )}
                        <Button
                            sx={{ ml: 2 }}
                            color="dark"
                            onClick={() => {
                                handleCreateOrUpdate();
                            }}
                        >
                            {props.mode === Mode.View ? <Edit /> : <Save />}
                            &nbsp;
                            {props.mode === Mode.View ? Strings.Common.EDIT : Strings.Common.SAVE}
                        </Button>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Card>
                        <BasicInfoChannel
                            mode={props.mode}
                            title={props.title}
                            dataError={dataError}
                            dataDetail={dataDetail}
                            onChangeValue={onChangeValueChannel}
                        />
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ChannelEditContainer;
